import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAvApi, TRoleDto } from '@app-velocity/av-api-v2';
import { useUserData } from '@app-velocity/libs/auth';

export const useAssignNewUserToWorkspaceMutation = () => {
  const { roleController } = useAvApi();
  const queryClient = useQueryClient();
  const user = useUserData();

  return useMutation({
    mutationKey: ['assing-new-user-to-workspace'],
    mutationFn: async ({ userId, projectId }: Omit<TRoleDto, 'role'>) => {
      const { data } = await roleController.postV2Roles({
        userId,
        projectId,
      });

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['projects', user.userId],
      });
    },
  });
};
